/* eslint-disable no-new-object */
import React, { useState, useEffect, useMemo } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import MUIDataTable from "mui-datatables";
import { Pagination } from "react-bootstrap";
import { Dropdown, Modal } from "react-bootstrap";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";
import { Link, useHistory } from "react-router-dom";
import {
  Button,
  makeStyles,
  TextField,
  createMuiTheme,
  MuiThemeProvider,
  CircularProgress,
} from "@material-ui/core";
import {
  getNoticeList,
  insertNotice,
  deleteNotice,
  getNoticeDetail,
  updateNotice,
} from "../modules/api";
import Moment from "moment";

export function Notice() {
  const [isShow, setIsShow] = useState(false);
  const [isEditShow, setIsEditShow] = useState(false);
  const [isDtlShow, setIsDtlShow] = useState(false);
  const [isShowDropMenu, setIsShowDropMenu] = useState(false);
  const history = useHistory();
  const [listLoading, setListLoading] = useState(false);
  const [noticeList, setNoticeList] = useState([]);
  const [userNo, setUserNo] = useState();
  const [noticeNo, setNoticeNo] = useState();
  const [dateInput, setDateInput] = useState({
    startDate: Moment(new Date()).format("YYYY-MM-DD"),
    endDate: Moment(new Date()).format("YYYY-MM-DD"),
  });
  const [input, setInput] = useState({
    title: "",
    contents: "",
    viewFor: "",
  });

  const fetchData = async () => {
    try {
      const result = await getNoticeList();
      console.log("notice", result);

      setUserNo(localStorage.getItem("userNo"));

      let list = [];
      result.data.map((data, index) => {
        var obj = new Object();
        obj.id = index + 1;
        obj.no = data.no;
        obj.title = data.title;
        obj.displayDate = data.startAt + " ~ " + data.endAt;
        obj.writer = data.user.loginId;
        obj.createdAt = Moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss");
        obj.userNo = data.user.no;
        list.push(obj);
      });

      setNoticeList(list);
    } catch (e) {
      console.log(e);
      // Handle error
    }
  };

  useEffect(() => {
    setListLoading(true);
    setTimeout(async () => {
      fetchData();
      setListLoading(false);
    }, 1000);
  }, []);

  const toggleShow = () => {
    setInput({
      title: "",
      contents: "",
      viewFor: "",
    });
    setIsShow(!isShow);
  };

  const toggleEditShow = () => {
    setIsEditShow(!isEditShow);
  };

  const toggleDtlShow = () => {
    setIsDtlShow(!isDtlShow);
  };

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    centeredHeader: {
      "& span": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        fontWeight: "bold",
      },
    },
  }));

  const classes = useStyles();
  // The first commit of Material-UI

  const handleDateChange = (e) => {
    if (e.target.name === "endDate") {
      if (Moment(dateInput.startDate).isAfter(e.target.value)) {
        alert("종료일은 시작일보다 작을 수 없습니다.");
        return false;
      }
    }
    setDateInput({
      ...dateInput,
      [e.target.name]: Moment(e.target.value).format("YYYY-MM-DD"),
    });
  };

  const handleChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  };

  const regNotice = async () => {
    // console.log(input.viewFor);
    if (!input.title.trim()) {
      alert("제목을 입력해주세요.");
      return false;
    }

    if (!input.contents.trim()) {
      alert("내용을 입력해주세요.");
      return false;
      }

    const role = localStorage.getItem("userRole");
    if (role === "BotAdmin") {
        input.viewFor = "bot";
    }
    else if (role === "SystemAdmin" && input.viewFor == "") {
        input.viewFor = "all";
    }
      console.log("input", input);
    const param = {
      title: input.title,
      contents: input.contents,
      viewFor: input.viewFor || "",
      startAt: dateInput.startDate,
      endAt: dateInput.endDate,
    };

    toggleShow();
    const res = await insertNotice(param);
    console.log("insertNotice", res);

    if (res.result) {
      alert("정상적으로 등록되었습니다.");
      fetchData();
      setInput({
        title: "",
        contents: "",
        viewFor: "all",
      });
      setDateInput({
        startDate: Moment(new Date()).format("YYYY-MM-DD"),
        endDate: Moment(new Date()).format("YYYY-MM-DD"),
      });
      return;
    } else {
      alert("정상적으로 등록되지 않았습니다.");
      return;
    }
  };

  const uptNotice = async () => {
    // console.log("noticeNo", noticeNo);
    if (input.title === "") {
      alert("제목을 입력해주세요.");
      return false;
    }

    if (input.contents === "") {
      alert("내용을 입력해주세요.");
      return false;
    }

    const param = {
      title: input.title,
      contents: input.contents,
      viewFor: input.viewFor || "",
      startAt: dateInput.startDate,
      endAt: dateInput.endDate,
    };

    const res = await updateNotice(noticeNo, param);
    // console.log("insertNotice", res);
    toggleEditShow();
    if (res.result) {
      alert("정상적으로 수정되었습니다.");
      fetchData();
      return;
    } else {
      alert("정상적으로 수정되지 않았습니다.");
      return;
    }
  };

  const editNotice = async (value) => {
    const res = await getNoticeDetail(value);
    console.log("noticeDtl", res);
    // setNoticeNo(value);
    setInput({ title: res.data.title, contents: res.data.contents });
    setDateInput({ startDate: res.data.startAt, endDate: res.data.endAt });
    setIsEditShow(true);
  };

  const viewNotice = async () => {
    const res = await getNoticeDetail(noticeNo);
    console.log("noticeDtl", res);
    // setNoticeNo(value);

      try {
          if (res.data.title === undefined) {
              res.data.title = "";
          }
          if (res.data.contents === undefined) {
              res.data.contents = "";
          }
          setInput({ title: res.data.title, contents: res.data.contents });
          setDateInput({ startDate: res.data.startAt, endDate: res.data.endAt });

          setIsDtlShow(true);
      } catch (e) {
          console.log(e);
      }
  };

  const delNotice = async (value) => {
    if (window.confirm("공지사항을 삭제하시겠습니까?")) {
      const res = await deleteNotice(value);
      if (res.result) {
        alert("정상적으로 삭제되었습니다.");
        fetchData();
      } else {
        alert("정상적으로 삭제되지 않았습니다.");
        return false;
      }
    }
  };

  const columns = [
    {
      name: "id",
      label: "번호",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "title",
      label: "제목",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "displayDate",
      label: "게시 기간",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "writer",
      label: "작성자",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "createdAt",
      label: "등록일",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "no",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "userNo",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "action",
      label: "작업",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center", fontSize: 15, fontWeight: "bold" },
        }),
        customBodyRender: (value, meta) => {
          // console.log("meta", meta.rowData);

          if (userNo.toString() === meta.rowData[6].toString()) {
            return (
              <div className="card-toolbar">
                <Dropdown className="dropdown-inline">
                  <Dropdown.Toggle
                    className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                    variant="transparent"
                    id="dropdown-autoClose-true"
                    as={DropdownCustomToggler}
                  >
                    <i className="ki ki-bold-more-hor" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                    {/* <ul className="navi"> */}
                    <Dropdown.Item
                      className="navi-item"
                      onClick={() => {
                        editNotice(meta.rowData[5]);
                      }}
                    >
                      수정
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="navi-item"
                      onClick={() => {
                        delNotice(meta.rowData[5]);
                      }}
                    >
                      삭제
                    </Dropdown.Item>
                    {/* </ul> */}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            );
          }
        },
      },
    },
  ];

  const options = {
    print: false,
    download: false,
    filter: false,
    rowsPerPage: 15,
    rowsPerPageOptions: [],
    viewColumns: false,
    selectableRows: "none",
    onRowClick: (rowData, rowState) => {
      // editNotice(rowData[5], "dtl");
      setNoticeNo(rowData[5]);
    },
    onCellClick: (cellData, cellMeta) => {
      if (cellMeta.colIndex !== 7) {
        viewNotice();
      }
      // editNotice(, "dtl");
    },
    textLabels: {
      body: {
        noMatch: listLoading ? (
          <CircularProgress size={25} color={"inherit"} />
        ) : noticeList ? (
          ""
        ) : (
          "검색 결과가 없습니다."
        ),
      },
    },
  };

  return (
    <div id="pageid34">
      {/* D2: 작성 버튼 선택 시 공지사항 작성 모달 활성화(수정 동일) 시작 */}
      <Modal
        show={isEditShow}

        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            공지사항 수정
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          <p>제목</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="제목을 입력해주세요."
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="title"
              value={input.title || ""}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <p>게시 기간</p>
          <div
            className="row form-group fv-plugins-icon-container"
            style={{ marginLeft: 10 }}
          >
            <div>
              <TextField
                id="startDate"
                type="date"
                name="startDate"
                // defaultValue={startDate}
                value={dateInput.startDate || ""}
                onChange={(e) => handleDateChange(e)}
                // value: Moment(recordAt).format("YYYY-MM-DD") || "",
                // defaultValue="2021-05-24"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div style={{ marginLeft: 15, marginRight: 15, paddingTop: 5 }}>
              ~
            </div>
            <div>
              <TextField
                id="endDate"
                type="date"
                name="endDate"
                value={dateInput.endDate || ""}
                onChange={(e) => handleDateChange(e)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>
          {localStorage.getItem("userRole") === "SystemAdmin" && (
            <div>
              <p>대상</p>
              <div className="form-group fv-plugins-icon-container">
                <select
                  className="form-control form-control-lg form-control-solid"
                  name="viewFor"
                  onChange={(e) => handleChange(e)}
                >
                  <option value="all">전체</option>
                  <option value="botAdmin">Bot관리자</option>
                  <option value="bot">Bot계정</option>
                </select>
              </div>
            </div>
          )}
          <p>내용</p>
          <div className="form-group fv-plugins-icon-container">
            <textarea
              placeholder="내용을 입력해주세요."
              className="modal-textarea"
              style={{ height: "150px" }}
              name="contents"
              value={input.contents || ""}
              onChange={(e) => handleChange(e)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleEditShow}
              className="btn btn-light btn-elevate"
            >
              취소
            </button>
            <> </>
            <button
              type="button"
              onClick={uptNotice}
              className="btn btn-primary btn-elevate"
            >
              수정
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* D2: 작성 버튼 선택 시 공지사항 작성 모달 활성화(수정 동일) 끝 */}

      {/* D6: 특정항목을 작성하지 않았을 시 시작 */}
      {/* <Modal show={isShow} onHide={toggleShow}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            공지사항 작성 오류
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-0">xxx항목을 작성해 주세요.</p>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShow}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal> */}
      {/* D6: 특정항목을 작성하지 않았을 시 끝 */}
      {/* pagdId60 공지사항 작성 모달 시작 */}
      <Modal
        show={isShow}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            공지사항 작성
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          <p>제목</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="제목을 입력해주세요."
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="title"
              value={input.title || ""}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <p>게시 기간</p>
          <div
            className="row form-group fv-plugins-icon-container"
            style={{ marginLeft: 10 }}
          >
            <div>
              <TextField
                id="startDate"
                type="date"
                name="startDate"
                // defaultValue={startDate}
                value={dateInput.startDate || ""}
                onChange={(e) => handleDateChange(e)}
                // value: Moment(recordAt).format("YYYY-MM-DD") || "",
                // defaultValue="2021-05-24"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div style={{ marginLeft: 15, marginRight: 15, paddingTop: 5 }}>
              ~
            </div>
            <div>
              <TextField
                id="endDate"
                type="date"
                name="endDate"
                value={dateInput.endDate || ""}
                onChange={(e) => handleDateChange(e)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>
          {localStorage.getItem("userRole") === "SystemAdmin" && (
            <div>
              <p>대상</p>
              <div className="form-group fv-plugins-icon-container">
                <select
                  className="form-control form-control-lg form-control-solid"
                  name="viewFor"
                  onChange={(e) => handleChange(e)}
                >
                  <option value="all">전체</option>
                  <option value="botAdmin">Bot관리자</option>
                  <option value="bot">Bot계정</option>
                </select>
              </div>
            </div>
          )}
          <p>내용</p>
          <div className="form-group fv-plugins-icon-container">
            <textarea
              placeholder="내용을 입력해주세요."
              className="modal-textarea"
              style={{ height: "150px" }}
              name="contents"
              value={input.contents || ""}
              onChange={(e) => handleChange(e)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShow}
              className="btn btn-light btn-elevate"
            >
              취소
            </button>
            <> </>
            <button
              type="button"
              onClick={regNotice}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isDtlShow}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">공지사항</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          <p>제목</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="제목을 입력해주세요."
              type="text"
              disabled={true}
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="title"
              value={input.title || ""}
              onChange={(e) => handleChange(e)}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            />
          </div>
          <p>게시 기간</p>
          <div
            className="row form-group fv-plugins-icon-container"
            style={{ marginLeft: 10 }}
          >
            <div>
              <TextField
                id="startDate"
                type="date"
                name="startDate"
                disabled={true}
                style={{
                  backgroundColor: "lightgrey",
                  borderCcolor: "lightgrey",
                }}
                // defaultValue={startDate}
                value={dateInput.startDate || ""}
                onChange={(e) => handleDateChange(e)}
                // value: Moment(recordAt).format("YYYY-MM-DD") || "",
                // defaultValue="2021-05-24"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div style={{ marginLeft: 15, marginRight: 15, paddingTop: 5 }}>
              ~
            </div>
            <div>
              <TextField
                id="endDate"
                type="date"
                name="endDate"
                disabled={true}
                style={{
                  backgroundColor: "lightgrey",
                  borderCcolor: "lightgrey",
                }}
                value={dateInput.endDate || ""}
                onChange={(e) => handleDateChange(e)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>
          {/* <p>대상</p>
					<div className="form-group fv-plugins-icon-container">
						<select
							className="form-control form-control-lg form-control-solid"
							name="language"
						>
							<option>전체</option>
							<option>전체</option>
							<option>전체</option>
						</select>
					</div> */}
          <p>내용</p>
          <div className="form-group fv-plugins-icon-container">
            <textarea
              placeholder="내용을 입력해주세요."
              className="modal-textarea"
              disabled={true}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
                height: "150px",
              }}
              name="contents"
              value={input.contents || ""}
              onChange={(e) => handleChange(e)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleDtlShow}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* pagdId60 공지사항 작성 모달 끝 */}
      <div style={{ marginTop: 30 }}>
        <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
          공지사항
        </h3>
      </div>
      <div
        className="top-row gutter-b d-flex align-items-center flex-column"
        style={{ marginTop: 50 }}
      >
        {/* <div className="input-icon h-40px">
					<input
						type="text"
						className="form-control form-control-lg form-control-solid h-40px bg-white"
						placeholder="검색"
						id="generalSearch"
						autoComplete="false"
					/>
					<span>
						<span className="svg-icon svg-icon-lg">
							<SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
						</span>
					</span>
				</div> */}
        <div className="d-flex align-items-center justify-content-end w-100">
          <div>
            <Button
              className={`btn btn-info font-weight-bolder font-size-sm mr-2`}
              onClick={toggleShow}
            >
              작성
            </Button>
          </div>
        </div>
      </div>
      {/* <MuiThemeProvider theme={getMuiTheme()}> */}
      <MUIDataTable
        // title={"공지사항"}
        data={noticeList}
        columns={columns}
        options={options}
      />

      {/* </MuiThemeProvider> */}
    </div>
  );
}
export default Notice;
